<template>
  <div class="main">
    <el-container>
      <el-header>健康水平实验评估系统</el-header>
      <el-main>
        <el-row class="main-box">
          <el-col :xs="24" :sm="24" :md="12" :lg="12" :xl="12" class="logo-box">
            <img style="width: 90%" src="../assets/logo.jpg"/>
            <img style="width: 300px" src="../assets/logo1.jpg" class="logo2"/>
          </el-col>
          <el-col :xs="24" :sm="24" :md="12" :lg="12" :xl="12">
            <div class="btn-box">
              <div class="box-head">您好，欢迎使用</div>
              <div>
                <el-row>
                  <router-link to="/form?mode=new"
                    ><el-button type="primary">输录数据</el-button></router-link
                  >
                </el-row>
                <el-row>
                  <router-link to="/form?mode=demo"
                    ><el-button type="primary" plain
                      >演示数据</el-button
                    ></router-link
                  >
                </el-row>
                <el-row>
                  <router-link to="/description"
                    ><el-button type="primary" plain
                      >系统说明</el-button
                    ></router-link
                  >
                </el-row>
                <!-- 暂时入口
                <el-row>
                  <router-link to="/report"
                    ><el-button type="primary" plain
                      >报告</el-button
                    ></router-link
                  >
                </el-row> -->
              </div>
            </div>
          </el-col>
        </el-row>
      </el-main>
      <el-footer>版本 V3.0</el-footer>
    </el-container>
  </div>
</template>

<script>
export default {
  name: "Index",
  data() {
    return {
      url1: "../assets/logo.jpg",
      url2: "../assets/logo1.jpg",
    };
  },
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang='scss'>
.el-button {
  width: 80%;
  margin: 0 auto;
}
.logo-box {
  margin: 20px 0;
}
.btn-box {
  margin: 0 auto;
  box-shadow: 0 5px 15px -5px rgba(0, 0, 0, 0.5);
  padding-bottom: 10px;
  max-width: 500px;
  .el-row {
    margin: 40px 0;
  }
}
.box-head {
  background-color: $green;
  height: 60px;
  line-height: 60px;
  color: #fff;
  font-size: 18px;
}
.main-box {
  display: flex;
  flex: 1;
  justify-content: center;
  align-items: center;
  width: 80%;
  height: 100%;
  margin: 0 auto;
}
@media screen and (max-width: 980px) {
  .main-box {
    width: 100%;
    display: block;
    height: auto;
  }
  .logo2 {
    display: none !important;
  }
  .btn-box {
    max-width: 100%;
  }
}
.el-image {
  display: block;
  margin: 0 auto;
}
</style>
